import axios from "@/api/config";

const wxSchoolPage = {
  getWxSchoolPageById(data) {
    return axios.get(
      `${process.env.BASE_URL}/wxSchoolPage/getWxSchoolPageById/` + data,
      {}
    );
  },
  getWxSchoolPageDetail(data) {
    return axios.get(
      `${process.env.BASE_URL}/wxSchoolPage/getWxSchoolPageDetail`,
      { params: data }
    );
  },
  getWxSchoolPage(data) {
    return axios.get(`${process.env.BASE_URL}/wxSchoolPage/getWxSchoolPage`, {
      params: data
    });
  },
  getWxSchoolPageList(data) {
    return axios.get(
      `${process.env.BASE_URL}/wxSchoolPage/getWxSchoolPageList`,
      { params: data }
    );
  },
  getWxSchoolPageTree(data) {
    return axios.get(
      `${process.env.BASE_URL}/wxSchoolPage/getWxSchoolPageTree`,
      { params: data }
    );
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/wxSchoolPage/pageList`, data);
  },
  addWxSchoolPage(data) {
    return axios.post(
      `${process.env.BASE_URL}/wxSchoolPage/addWxSchoolPage`,
      data
    );
  },
  updateWxSchoolPage(data) {
    return axios.put(
      `${process.env.BASE_URL}/wxSchoolPage/updateWxSchoolPage`,
      data
    );
  },
  updateWxSchoolPageByTemplateId(data) {
    return axios.post(
      `${process.env.BASE_URL}/wxSchoolPage/updateWxSchoolPageByTemplateId`,
      data
    );
  },
  deleteWxSchoolPage(data) {
    return axios.delete(
      `${process.env.BASE_URL}/wxSchoolPage/deleteWxSchoolPage`,
      { data: data }
    );
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/wxSchoolPage/exportExcel`, {
      params: data
    });
  },
  importData(data) {
    return axios.post(`${process.env.BASE_URL}/wxSchoolPage/importData`, data);
  },
  active(data) {
    return axios.post(`${process.env.BASE_URL}/wxSchoolPage/active`, data);
  }
};

export default wxSchoolPage;



// WEBPACK FOOTER //
// ./src/api/wxSchoolPage.js